import React from 'react';
import PropTypes from 'prop-types';

export const CarouselItem = ({ isActive, currentIndex, children }) => {
    const carouselItemClassName = `carousel-item  ${isActive ? 'active' : ''}`;
    const carouselItemStyle = { transform: `translateX(-${currentIndex * 100}%)` };

    return (
        <div className={carouselItemClassName} style={carouselItemStyle} data-testid="carousel-item">
            {children}
        </div>
    );
};
CarouselItem.propTypes = {
    isActive: PropTypes.bool,
    currentIndex: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
};
